import _ from 'lodash'
import ua from 'ua'
import orderService from 'service/order'
import defaultConfig from './default'
import { shared } from "progress";

const hosts = ua.isBeta() ? 'https://waptest.myzebravip.com/order/thirdParty/cashier' : 'https://wap.myzebravip.com/order/thirdParty/cashier'
const loginType = 17

module.exports = _.merge({}, defaultConfig, {
  name: 'banma',
  hideCoupon: true,
  hideGiftCard: true,
  isListHome: true,
  showUserEntry: false,
  isNeedLogin: true,
  hideReview: true,
  hideRelatedActivity: true,
  match() {
    let userAgent = navigator.userAgent.toLowerCase()
    return /zebra/.test(userAgent)
  },
  login(redir) {
    const user = require('user')
    return user.banmaLogin(redir, loginType)
  },
  async pay(data) {
    let promises = ''
    const isGetBanmaId = typeof data === 'number'
    if (isGetBanmaId) {
      promises = orderService.banmaGetOrderId(data)
    } else {
      const user = require('user')
      const account = await user.getBanmaAccountId()
      data['accountId'] = +account.accountId
      promises = orderService.banmaMakeOrder(data)
    }
    promises
      .then(({ zebraChannel, orderSerialId, productType }) => {
        location.href = `${hosts}?zebraChannel=${zebraChannel}&orderSerialId=${orderSerialId}&productType=${productType}&ggjRedirect=1`
      })
      .catch((hint) => {
        shared.showMessage(hint)
      })
  }
})



// WEBPACK FOOTER //
// ./src/mods/channels/banma.js